/** Roles que se pueden asignar a un asistente: activos, más el actual si ya lo tiene (aunque esté inactivo). */
export function assignableRoles<T extends { id: string; isActive: boolean }>(
  roles: T[],
  keepRoleId?: string | null
): T[] {
  const keep = keepRoleId?.trim() || null;
  return roles.filter((role) => role.isActive || role.id === keep);
}
